import React from 'react';
import PropTypes from 'prop-types';

import cafeteria from './benefit_icons/cafeteria';
import coffee_snacks from './benefit_icons/coffee_snacks';
import external_services from './benefit_icons/external_services';
import gym from './benefit_icons/gym';
import health_insurance from './benefit_icons/health_insurance';
import life_insurance from './benefit_icons/life_insurance';
import pension_fund from './benefit_icons/pension_fund';
import stock_plan from './benefit_icons/stock_plan';
import wellness from './benefit_icons/wellness';
import commuting_stipend from './benefit_icons/commuting_stipend';
import cars_ebikes from './benefit_icons/cars_ebikes';
import child_care_stipend from './benefit_icons/child_care_stipend';
import sabbatical from './benefit_icons/sabbatical';
import remote_work from './benefit_icons/remote_work';
import wfh from './benefit_icons/wfh';
import top_equipement from './benefit_icons/top_equipement';
import top_furniture from './benefit_icons/top_furniture';
import learning_opportunities from './benefit_icons/learning_opportunities';
import pet_friendly_office from './benefit_icons/pet_friendly_office';
import dental_coverage from './benefit_icons/dental_coverage';
import equity_incentives from './benefit_icons/equity_incentives';
import timeoff_moving_exams from './benefit_icons/timeoff_moving_exams';
import additional_custom_bonus from './benefit_icons/additional_custom_bonus';
import custom_health_bonus from './benefit_icons/custom_health_bonus';
import custom_financial_bonus from './benefit_icons/custom_financial_bonus';
import custom_discount_bonus from './benefit_icons/custom_discount_bonus';
import custom_timeoff_bonus from './benefit_icons/custom_timeoff_bonus';
import custom_work_env_bonus from './benefit_icons/custom_work_env_bonus';
import extra_maternity_paternity_leave from './benefit_icons/extra_maternity_paternity_leave';

const iconsMap = {
  cafeteria,
  coffee_snacks,
  external_services,
  gym,
  health_insurance,
  life_insurance,
  pension_fund,
  stock_plan,
  wellness,
  commuting_stipend,
  cars_ebikes,
  child_care_stipend,
  sabbatical,
  remote_work,
  wfh,
  top_equipement,
  top_furniture,
  learning_opportunities,
  pet_friendly_office,
  dental_coverage,
  equity_incentives,
  timeoff_moving_exams,
  additional_custom_bonus,
  custom_health_bonus,
  custom_financial_bonus,
  custom_discount_bonus,
  custom_timeoff_bonus,
  custom_work_env_bonus,
  extra_maternity_paternity_leave,
};

const BenefitIcon = ({ icon, wrapperClasses = '', companyColour = '' }) => {
  const Icon = iconsMap[icon] ?? cafeteria;
  return (
    <div className={wrapperClasses}>
      <Icon companyColour={companyColour} />
    </div>
  );
};

BenefitIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  wrapperClasses: PropTypes.string,
  companyColour: PropTypes.string,
};

export default BenefitIcon;
